<div class="transaction-detail grey-text" data-qa-block="transaction-totals">
  <div class="detail-row">
    <span class="detail-row__item" data-qa="cash">
      {{ 'kkms.kkm.report.tickets.cash' | translate }}
      {{ transactionTotalResult?.cash || 0 | kzCurrencyDecimal }}
    </span>
    <span class="detail-row__item" data-qa="revenue">
      {{ 'kkms.kkm.report.tickets.revenue' | translate }}
      {{ transactionTotalResult?.revenue || 0 | kzCurrencyDecimal }}
    </span>
  </div>
  <div class="detail-row">
    <span class="detail-row__item" data-qa="sell">
      {{ 'kkms.kkm.report.ticketsType.sell' | translate }}:
      {{ transactionTotalResult?.SELL.count || 0 }}
    </span>
    <span class="detail-row__item" data-qa="sell-return">
      {{ 'kkms.kkm.report.ticketsType.sell_return' | translate }}:
      {{ transactionTotalResult?.SELL_RETURN.count || 0 }}
    </span>
  </div>
  <div class="detail-row">
    <span class="detail-row__item" data-qa="buy">
      {{ 'kkms.kkm.report.ticketsType.buy' | translate }}:
      {{ transactionTotalResult?.BUY.count || 0 }}
    </span>
    <span class="detail-row__item" data-qa="buy-return">
      {{ 'kkms.kkm.report.ticketsType.buy_return' | translate }}:
      {{ transactionTotalResult?.BUY_RETURN.count || 0 }}
    </span>
  </div>
</div>
